import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale, iconSize } from '@/theme';
import { mq } from '../../theme/scalingTokens';

export const useHeaderStyles = makeStyles({
  root: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '3rem',
    backgroundColor: tokens.colorBrandStroke2Pressed,
    color: tokens.colorNeutralForegroundOnBrand,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 1000,
    ...shorthands.padding('0', tokens.spacingHorizontalL),
    boxSizing: 'border-box',
  },
  rootWithWaffle: {
    paddingLeft: '0',
  },
  titleButtonWithWaffle: {
    marginLeft: tokens.spacingHorizontalM,
  },
  title: {
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightSemibold,
    whiteSpace: 'nowrap',
    marginRight: tokens.spacingHorizontalM,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [mq.mobile]: {
      fontSize: fontScale.body,
      marginRight: tokens.spacingHorizontalS,
      maxWidth: '6.25rem',
    },
  },
  titleButton: {
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightSemibold,
    whiteSpace: 'nowrap',
    marginRight: tokens.spacingHorizontalM,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'inherit',
    backgroundColor: 'transparent',
    ...shorthands.border('none'),
    ...shorthands.padding('0'),
    cursor: 'pointer',
    ':hover': {
      opacity: 0.85,
    },
    [mq.mobile]: {
      fontSize: fontScale.body,
      marginRight: tokens.spacingHorizontalS,
      maxWidth: '6.25rem',
    },
  },
  commands: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
    ...shorthands.gap(tokens.spacingHorizontalS),
  },
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '2.75rem',
    minHeight: '2.75rem',
    ...shorthands.padding('0'),
    ...shorthands.border('none'),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    backgroundColor: 'transparent',
    color: tokens.colorNeutralForegroundOnBrand,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
    ':focus-visible': {
      outlineStyle: 'solid',
      outlineWidth: '2px',
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: '2px',
    },
  },
  iconImg: {
    width: iconSize(20),
    height: iconSize(20),
    display: 'block',
  },
  icon: {
    width: iconSize(20),
    height: iconSize(20),
    display: 'block',
    fontSize: iconSize(20),
  },
  notificationsWrapper: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  },
  badge: {
    position: 'absolute',
    top: '0.125rem',
    right: '0.125rem',
    pointerEvents: 'none',
  },
});
